import {
  request,
  METHOD
} from '@/utils/request.js'


// 自动模式保存
export function save(data) {
  return request(
    '/h5Mfitness/device/save',
    METHOD.POST,
    data
  )
}
// 手动模式保存
export function saveToo(data) {
  return request(
    '/h5Mfitness/device/saveToo',
    METHOD.POST,
    data
  )
}

// 列表
export function getFlowableSchoolCorxInfoList(data) {
  return request(
    '/h5Mfitness/device/getFlowableSchoolCorxInfoList',
    METHOD.POST,
    data
  )
}
// 列表
export function getFlowableSchoolCorxInfoTimeList(data) {
  return request(
    '/h5Mfitness/device/getFlowableSchoolCorxInfoTimeList',
    METHOD.POST,
    data
  )
}

// 设备列表
export function selectSchoolDeviceList(data) {
  return request(
    '/h5Mfitness/deviceH5Fitness/selectSchoolDeviceList',
    METHOD.POST,
    data
  )
}
// 查询设备状态
export function selectSchoolDeviceStatus(data) {
  return request(
    '/h5Mfitness/deviceH5Fitness/selectSchoolDeviceStatus',
    METHOD.POST,
    data
  )
}


// 切换设备项目接口
export function chooseDeviceProject(data) {
  return request(
    'h5Mfitness/deviceH5Fitness/chooseDeviceProject',
    METHOD.POST,
    data
  )
}
// 设置设备时间段项目
export function setWeekDeviceInfo(data) {
  return request(
    'h5Mfitness/deviceH5Fitness/setWeekDeviceInfo',
    METHOD.POST,
    data
  )
}
// 查看每周计划
export function selectWeekDeviceInfo(data) {
  return request(
    'h5Mfitness/deviceH5Fitness/selectWeekDeviceInfo',
    METHOD.POST,
    data
  )
}

// 跳跳乐园项目切换list
export function selectSchoolDeviceProjectCodeList(data) {
  return request(
    'h5Mfitness/deviceH5Fitness/selectSchoolDeviceProjectCodeList',
    METHOD.POST,
    data
  )
}


export function updateDeviceVideoName(data) {
  return request(
    'web/admin/deviceWeb/updateDeviceVideoName',
    METHOD.POST,
    data
  )
}


